import OutboundDealsApi from 'api/admins/outbound-deals-api'
import { TitlePage } from 'components/atoms'
import { ALERT_TYPES } from 'constants/alert-constants'
import OutboundDealsView from 'domains/outbound/deals/view/outbound-deals-view'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const OutboundDealsDetailPage = ({ pageUtils }) => {
  const { id } = useParams()
  const [ deal, setDeal ] = useState({})
  const [ historyList, setHistoryList ] = useState([])
  const [ historyDetail, setHistoryDetail ] = useState({})
  const [ isLoading, setIsLoading ] = useState(true)
  const [ completing, setCompleting ] = useState(false)
  const [ completeError, setCompleteError ] = useState('')
  const [ completeOpen, setCompleteOpen ] = useState(false)

  const completeDeal = async () => {
    if (completing) return
    setCompleting(true)
    setCompleteError('')
    try {
      const response = await OutboundDealsApi.complete({ dealId: id })
      setCompleteOpen(false)
      pageUtils.setAlertMsg(response.data.message, ALERT_TYPES.SUCCESS)
      fetchDeal()
    } catch (error) {
      setCompleteError(error.response?.data?.message || 'Deal gagal diselesaikan.')
    } finally {
      setCompleting(false)
    }
  }

  const fetchDeal = () => {
    setIsLoading(true)

    OutboundDealsApi.show({ dealId: id })
      .then((response) => { setDeal(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
      .finally(() => { setIsLoading(false) })
  }
  const updatePacking = (values, formikBag) => {
    OutboundDealsApi.updatePacking({ dealId: id, ...values })
      .then((response) => {
        if(response.status === 200){
          const msg = 
          <>
            { 'Packing data berhasil diubah' } &nbsp;
            <Button onClick={fetchDeal} block color="info" className='mb-3'>Klik disini untuk Refresh Data</Button>
          </>
          pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
          fetchDeal()
        }
      })
      .catch((error) => {
        formikBag.setErrors(error.response.data.messages)
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => {
        formikBag.setSubmitting(false)
      })
  }
  const updateShipment = (values, formikBag) => {
    OutboundDealsApi.updateShipment({ dealId: id, ...values })
      .then((response) => {
        if(response.status === 200){
          const msg = response.data.state === 'completed' ? 'Barang diserahkan dan Deal selesai.' : response.data.message || 'Shipment data berhasil diubah'
          pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
          fetchDeal()
        }
      })
      .catch((error) => {
        formikBag.setErrors(error.response.data.messages)
        pageUtils.setApiErrorMsg(error.response.data)
      })
      .finally(() => {
        formikBag.setSubmitting(false)
      })
  }
  const orderPickup = () => {
    OutboundDealsApi.orderPickup({ dealId: id })
      .then((response) => {
        if(response.status === 200){
          const msg = 'Request pickup berhasil'
          pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
          fetchDeal()
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data.messages)
      })
  }

  const fetchHistoryList = () => {
    OutboundDealsApi.listHistory({ dealId: id })
      .then((response) => { setHistoryList(response.data?.data?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const fetchHistoryDetail = (id) => {
    OutboundDealsApi.getHistory({ historyId: id })
      .then((response) => { setHistoryDetail(response.data.data) })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data.message))
  }
  const clearHistoryDetail = () => {
    setHistoryDetail({})
  }

  useEffect(() => {
    fetchDeal()
  }, [ id ])

  return (
    <>
      <TitlePage mainTitle={ 'Outbound Deal' }/>
      { (deal.state === 'on_delivery' || (deal.state === 'waiting_for_shipment' && deal.shipment?.method_type === 'self_pick_up')) && (
        <div className='mb-3'>
          <Button color='success' disabled={ completing } onClick={ () => { setCompleteError(''); setCompleteOpen(true) } }>Complete Deal / Barang Diterima</Button>
          <Modal isOpen={ completeOpen } toggle={ () => !completing && setCompleteOpen(false) }>
            <ModalHeader>Konfirmasi Barang Diterima</ModalHeader>
            <ModalBody>
              Pastikan barang sudah diterima pembeli. Deal akan menjadi Completed.
              { completeError && <div role='alert' className='text-danger mt-3'>{ completeError }</div> }
            </ModalBody>
            <ModalFooter>
              <Button color='secondary' disabled={ completing } onClick={ () => setCompleteOpen(false) }>Kembali</Button>
              <Button color='success' disabled={ completing } onClick={ completeDeal }>{ completing ? 'Memproses...' : 'Konfirmasi Selesai' }</Button>
            </ModalFooter>
          </Modal>
        </div>
      ) }
      <OutboundDealsView
        updatePacking={ updatePacking }
        updateShipment={ updateShipment }
        orderPickup={ orderPickup }
        fetchDeal={ fetchDeal }
        deal={ deal }
        fetchHistoryList={ fetchHistoryList }
        fetchHistoryDetail={ fetchHistoryDetail }
        clearHistoryDetail={ clearHistoryDetail }
        historyList={ historyList }
        historyDetail={ historyDetail }
        isLoading={ isLoading }
      />
    </>
  )
}

OutboundDealsDetailPage.propTypes = propTypes

export default OutboundDealsDetailPage